/**
 * Feature switches read in the browser.
 *
 * Event tickets are built and deployed, but hidden until P1 is live in a given environment:
 * `apphosting.yaml` keeps the P1 block commented out on production, so the pages there would
 * only say «coming soon». A switch keeps the menu honest without shipping a code change on the
 * day the feature is turned on — set NEXT_PUBLIC_SHOW_EVENT_TICKETS alongside the P1 variables.
 *
 * NEXT_PUBLIC_* values are baked at build time, so changing this needs a rollout, not a restart.
 */
export const showEventTickets = process.env.NEXT_PUBLIC_SHOW_EVENT_TICKETS === 'true';
